import { toast } from "react-toastify";

import PROFILE_FIELD from "Constants/profileFields";

import { ApiService } from "Services/api";
import { getPreparedUserData, ACCOUNT_TYPE } from "Services/user";
import I18nService from "Services/i18n";
import { ObjectTransformer } from "Services/Transformers";

export const PASSWORD = {
  CURRENT_PASSWORD: "old_password",
  NEW_PASSWORD: "password",
  NEW_CONFIRM_PASSWORD: "confirmation",
};

const USER_SSP_API_ROLES = {
  PUBLIC_API_BASE_USER: "ROLE_PUBLIC_API_BASE_USER",
  PUBLIC_API_EXTENDED_USER: "ROLE_PUBLIC_API_EXTENDED_USER",
  PUBLIC_API_SUPERUSER: "ROLE_PUBLIC_API_SUPERUSER",
};

function prepareProfileToClient(user) {
  const preparedData = {
    [PROFILE_FIELD.EMAIL]: user[PROFILE_FIELD.EMAIL],
    [PROFILE_FIELD.CITY]: user.contact_info[PROFILE_FIELD.CITY],
    [PROFILE_FIELD.ADDRESS]: user.contact_info[PROFILE_FIELD.ADDRESS],
    [PROFILE_FIELD.MESSENGER]: user.contact_info[PROFILE_FIELD.MESSENGER],
    [PROFILE_FIELD.MESSENGER_TYPE]: user.contact_info[PROFILE_FIELD.MESSENGER_TYPE],
    [PROFILE_FIELD.PHONE_NUMBER]: user.contact_info[PROFILE_FIELD.PHONE_NUMBER],
    [PROFILE_FIELD.LANGUAGE]: user.meta_data[PROFILE_FIELD.LANGUAGE],
    [PROFILE_FIELD.IS_AGREE_NEWS_LETTER]:
      user.meta_data[PROFILE_FIELD.IS_AGREE_NEWS_LETTER],
    [PROFILE_FIELD.LINKED_PUBLISHER_ID]:
      user.meta_data[PROFILE_FIELD.LINKED_PUBLISHER_ID],
    [PROFILE_FIELD.VAT]: user.legal_info[PROFILE_FIELD.VAT],
    [PROFILE_FIELD.LAST_NAME]: user.legal_info[PROFILE_FIELD.LAST_NAME],
    [PROFILE_FIELD.FIRST_NAME]: user.legal_info[PROFILE_FIELD.FIRST_NAME],
    [PROFILE_FIELD.ACCOUNT_TYPE]: String(
      user.legal_info[PROFILE_FIELD.ACCOUNT_TYPE]
    ),
    [PROFILE_FIELD.COMPANY_NAME]: user.legal_info[PROFILE_FIELD.COMPANY_NAME],
    [PROFILE_FIELD.BENEFICIARY_ID]:
      user.legal_info[PROFILE_FIELD.BENEFICIARY_ID],
    [PROFILE_FIELD.RESIDENCE_COUNTRY]:
      user.legal_info[PROFILE_FIELD.RESIDENCE_COUNTRY],
    [PROFILE_FIELD.TERMS_AND_CONDITIONS_OURS_AGREED_AT]: Boolean(
      user.legal_info[PROFILE_FIELD.TERMS_AND_CONDITIONS_OURS_AGREED_AT]
    ),
    [PROFILE_FIELD.ROLES]: user[PROFILE_FIELD.ROLES],
    [PROFILE_FIELD.IS_FEATURE_REQUEST_AVAILABLE]: Boolean(
      user.meta_data[PROFILE_FIELD.IS_FEATURE_REQUEST_AVAILABLE]
    ),
    [PROFILE_FIELD.PUB_TYPE]: user.meta_data[PROFILE_FIELD.PUB_TYPE],
  };

  if (
    String(user.legal_info[PROFILE_FIELD.ACCOUNT_TYPE]) ===
    ACCOUNT_TYPE.INDIVIDUAL
  ) {
    delete preparedData[PROFILE_FIELD.VAT];
    delete preparedData[PROFILE_FIELD.COMPANY_NAME];
  }

  return preparedData;
}

class Profile {
  get() {
    return ApiService.get("/profile/").then((result) => {
      return prepareProfileToClient(result);
    });
  }

  async update(user, isAcceptOurTerms) {
    const defaultLanguage = I18nService.getDefaultLanguage();
    const preparedData = getPreparedUserData(user, defaultLanguage);
    delete preparedData[PROFILE_FIELD.EMAIL];
    delete preparedData.legal_info[PROFILE_FIELD.RESIDENCE_COUNTRY];
    //delete preparedData.legal_info[PROFILE_FIELD.FIRST_NAME];
    //delete preparedData.legal_info[PROFILE_FIELD.LAST_NAME];
    delete preparedData.legal_info[PROFILE_FIELD.COMPANY_NAME];
    delete preparedData.legal_info[PROFILE_FIELD.VAT];
    if (isAcceptOurTerms) {
      delete preparedData.legal_info[PROFILE_FIELD.ADDRESS];
    }

    if (isAcceptOurTerms) {
      delete preparedData.contact_info[PROFILE_FIELD.CITY];
    }

    if (user[PROFILE_FIELD.ACCOUNT_TYPE] === ACCOUNT_TYPE.INDIVIDUAL) {
      delete preparedData[PROFILE_FIELD.VAT];
      delete preparedData[PROFILE_FIELD.COMPANY_NAME];
    }

    const newUser = await ApiService.patch("/profile/", preparedData);

    toast.success(I18nService.getStringByKey("toast_success-profile-update"));
    return prepareProfileToClient(newUser);
  }

  setLanguage(language) {
    return ApiService.patch(`/profile/`, { meta_data: { language } });
  }

  changePassword(currentPassword, newPassword, newConfirmPassword) {
    const preparedData = {
      [PASSWORD.CURRENT_PASSWORD]: currentPassword,
      password: {
        [PASSWORD.NEW_PASSWORD]: newPassword,
        [PASSWORD.NEW_CONFIRM_PASSWORD]: newConfirmPassword,
      },
    };

    return ApiService.post("/change_password/", preparedData);
  }

  getBeneficiaryName(profile) {
    if (profile[PROFILE_FIELD.ACCOUNT_TYPE] === ACCOUNT_TYPE.INDIVIDUAL) {
      return `${profile[PROFILE_FIELD.FIRST_NAME]} ${
        profile[PROFILE_FIELD.LAST_NAME]
      }`;
    }

    return `${profile[PROFILE_FIELD.COMPANY_NAME]}`;
  }

  isSspApiAvailable(userRoles) {
    if (!Array.isArray(userRoles)) {
      return false;
    }

    const sspApiRoles = ObjectTransformer.toArray(USER_SSP_API_ROLES);
    for (let i = 0; i < sspApiRoles.length; i += 1) {
      if (userRoles.includes(sspApiRoles[i])) {
        return true;
      }
    }

    return false;
  }
}

const profileInstance = new Profile();

export default profileInstance;